<template>
  <b-modal
    id="modal-newPackage"
    title="Dodaj nov paket"
    size="lg"
    body-bg-variant="light"
    header-bg-variant="secondary"
    header-text-variant="dark"
    ok-disabled
    centered
  >
    <b-row class="mt-5 justify-content-center">
      <b-col md="10">
        <b-form class="newProject">
          <b-form-row>
            <b-col cols="12">
              <b-form-group description="Naziv paketa">
                <b-input
                  required
                  size="md"
                  v-model="form.title"
                  type="text"
                  placeholder="Paket XYZ"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="6">
              <b-form-checkbox
                id="checkbox-1"
                v-model="form.rewards"
                name="rewards"
                value="1"
                unchecked-value="0"
                class="mb-2"
              >
                Paket ima charity donacijo.
              </b-form-checkbox>
            </b-col>
            <b-col cols="6">
              <b-form-group
                description="Povezava do splošnih pogojev nagradne igre."
              >
                <b-input
                  required
                  size="md"
                  v-model="form.reward_terms"
                  type="text"
                  placeholder="https://brevisvelox.com/some_terms"
                  :disabled="form.rewards ? false : true"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Intro tekst</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže na začetku paketa.</small
              >
              <TipTap
                v-bind:richdata="form.intro_text"
                @htmlChange="introChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Tekst Forma</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže ob prikaže ob formi paketa.</small
              >
              <TipTap
                v-bind:richdata="form.form_text"
                @htmlChange="formTextChanged"
              />
            </b-col>
          </b-form-row>
          <b-form-row class="mt-3">
            <b-col cols="12">
              <h6 class="mb-0">Tekst Finiš</h6>
              <small class="text-muted"
                >Tekst, ki se prikaže, ko uporabnik zaključi vse ankete v
                paketu.</small
              >
              <TipTap
                v-bind:richdata="form.finish_text"
                @htmlChange="finishTextChanged"
              />
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <template v-slot:modal-footer>
      <b-button
        @click="$bvModal.hide('modal-newProject')"
        class="btn btn-muted btn-md"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        @click="onSubmit"
        class="btn btn-dark btn-md"
        :disabled="isSending"
      >
        Ustvari nov projekt
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import axios from "axios";
import TipTap from "@/components/tools/TipTap.vue";

export default {
  components: { TipTap },
  data() {
    return {
      isSending: false,
      form: {
        title: "",
        rewards: 0,
        rewards_terms: "",
        finish_text: "",
      },
    };
  },
  mounted: function() {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isSending = true;

      this.form.rewards = parseInt(this.form.rewards);

      let submitData = this.form;

      return new Promise((resolve, reject) => {
        axios({
          url: this.$store.state.login.url + "/api/dashboard/packages/new",
          headers: {
            Authorization: `Bearer ${this.$store.state.login.token}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(submitData),
          method: "POST",
        })
          .then((response) => {
            // cleanup form
            this.isSending = false;
            this.$bvModal.hide("modal-newPackage");
            this.$router.go();
            this.$bvToast.toast(response.data.message, {
              title: "Success",
              autoHideDelay: 5000,
            });
            resolve(response);
          })
          .catch((err) => {
            this.isSending = false;
            this.$bvToast.toast(err.message, {
              title: "Something went wrong ... ",
              autoHideDelay: 5000,
            });
            reject(err);
          });
      });
    },
    introChanged(value) {
      this.form.intro_text = value;
    },
    formTextChanged(value) {
      this.form.form_text = value;
    },
    finishTextChanged(value) {
      this.form.finish_text = value;
    },
  },
};
</script>
